import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';

export const Wrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  min-height: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  
  @media (min-width: ${breakpoints.desktop}) {
      min-height: 0;
  }
  
`;

export const ErrorWrapper = styled.div`
  text-align: left;
  align-self: flex-end;
`;

export const ErrorText = styled.p`
  margin: 0;
  text-align: left;
`;

export const Row = styled.div`
  width: 100%;
  
  @media (min-width: ${breakpoints.desktop}) {
      margin: 10px 0!important;
      width: 50%;
  }
`
